import React from "react";
import "./style.css";
import { Label } from "reactstrap";
import { Button, Input, message, Select } from "antd";
import { LockOutlined } from "@ant-design/icons";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import { Form, DatePicker } from "antd";

const { Option } = Select;

export default class Vendors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ClickedProgram: [],

      submittedForm: [],
      loader: false,

      signInEmail: "",
      signInPassword: "",

      errors: "",
      sameEmailError: "",

      //userData: this.props.data,
      loadings: [],
      isForgotPassword: false,
      isSignUp: false,
      dob: null,
      showPasswordEnteries: false,
      password1: "",
      password2: "",

      id: "",
      firstName: "",
      lastName: "",
      dob: "",
      csrHeadcount: "",
      phone: "",
      experiencedPrograms: "",
      email: "",
      skypeId: "",
      organization: "",
      password1: "",
      password2: "",
    };
  }

  componentDidMount = () => {
    this.setState({ ClickedProgram: this.props.ClickedProgram });
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.vendorSignin();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  };

  onEmailChange = (event) => {
    this.setState({ signInEmail: event.target.value });
  };

  handleChange = (value) => {
    if (value) {
      const dateFormat = value.format("YYYY-MM-DD");
      const dateInString = JSON.stringify(dateFormat);
      this.setState({ dob: dateInString });
    }
  };

  onPasswordChange = (event) => {
    this.setState({ signInPassword: event.target.value });
  };

  onPassword1Change = (event) => {
    this.setState({ password1: event.target.value });
  };

  onPassword2Change = (event) => {
    this.setState({ password2: event.target.value });
  };

  cancel = () => {
    this.setState({
      showPasswordEnteries: false,
      password1: "",
      password2: "",
      dob: null,
      isForgotPassword: false,
      isSignUp: false,
      id: "",
      firstName: "",
      lastName: "",
      csrHeadcount: "",
      phone: "",
      experiencedPrograms: "",
      email: "",
      skypeId: "",
      organization: "",
      password1: "",
      password2: "",
      sameEmailError: "",
    });
  };

  forgotPassword = () => {
    console.log("forgot password");
    if (!this.state.signInEmail) {
      alert("Enter email first");
    } else {
      if (this.state.showPasswordEnteries) {
        if (
          this.state.password1 &&
          this.state.password2 &&
          this.state.password1 === this.state.password2
        ) {
          console.log(
            "password matched, fetching with password",
            this.state.password1
          );

          fetch(
            "https://work-web-server.herokuapp.com/vendors/forgotPassword",
            //"http://localhost:5000/vendors/forgotPassword",
            {
              method: "post",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                email: this.state.signInEmail,
                dob: this.state.dob,
                password: this.state.password1,
              }),
            }
          )
            .then((response) => response.json())
            .then((res) => {
              console.log(res);
              if (res === "Vendor not found") {
                console.log("Invalid Enteries");
                alert("Invalid Enteries");
              } else if (res === "Vendor found") {
                console.log("Show Password Enteries");
                this.setState({ showPasswordEnteries: true });
              } else if (res === "Password Updated") {
                message.success({
                  content: "Password Updated",
                  style: {
                    marginTop: "5vh",
                    lineHeight: "5vh",
                  },
                });
                this.setState({
                  isForgotPassword: false,
                  showPasswordEnteries: false,
                  password1: "",
                  password2: "",
                  dob: null,
                  signInEmail: "",
                  signInPassword: "",
                });
              }
            });
        } else {
          alert("Passwords do not match");
        }
      } else {
        console.log("No password");
        fetch(
          "https://work-web-server.herokuapp.com/vendors/forgotPassword",
          //"http://localhost:5000/vendors/forgotPassword",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: this.state.signInEmail,
              dob: this.state.dob,
            }),
          }
        )
          .then((response) => response.json())
          .then((res) => {
            console.log(res);
            if (res === "Vendor not found") {
              console.log("Invalid Enteries");
              message.warning({
                content: "Invalid Enteries!",
                duration: 2,
                style: {
                  marginTop: "5vh",
                  lineHeight: "5vh",
                },
              });
            } else if (res === "Vendor found") {
              console.log("Show Password Enteries");
              this.setState({ showPasswordEnteries: true });
            }
          });
      }
    }
  };

  onSubmit = () => {
    console.log("Submit function called", this.state);
    message.loading({
      content: "Submitting..",
      style: {
        marginTop: "10vh",
      },
    });
    this.setState({ loader: true });
    console.log("On submit", this.state);
    setTimeout(() => {
      fetch(
        "https://work-web-server.herokuapp.com/vendors/register",
        // "http://localhost:5000/vendors/register",
        {
          method: "POST",
          // mode: 'no-cors',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            csrHeadcount: this.state.csrHeadcount,
            phone: this.state.phone,
            experiencedPrograms: this.state.experiencedPrograms,
            email: this.state.email,
            skypeId: this.state.skypeId,
            organization: this.state.organization,
            dob: this.state.dob,
            password: this.state.password1,
            programName: this.props.ClickedProgram.programName,

            nodemailerType: "vendorRegister",
            nodemailerName: this.state.firstName + " " + this.state.lastName,
            nodemailerEmail: this.state.email,
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response === "Vendor exists") {
            this.setState({ sameEmailError: "Email already exists" });
          }
          console.log(response);
          if (response._id) {
            this.setState({
              id: response._id,
              submittedForm: response,
              loader: false,
              isSignUp: false,
            });
            message.success({
              content: "Congrats! You have successfully signed up",
              style: {
                marginTop: "5vh",
                lineHeight: "5vh",
              },
            });
          } else if (response && !response._id) {
            console.log(response);
            this.setState({
              loader: false,
              errors: response,
            });

            message.warning({
              content: "Invalid Enteries!",
              duration: 2,
              style: {
                marginTop: "5vh",
                lineHeight: "5vh",
              },
            });
          } else {
            console.log(response);
          }
          console.log(this.state);
        })
        .catch((error) => {
          // this.setState({ errorMessage: error.toString() });
          this.setState({
            loader: false,
          });
          message.warning({
            content: `Connection Failed!: ${error}`,
            duration: 4,
            style: {
              marginTop: "5vh",
              lineHeight: "5vh",
            },
          });
          console.error("There was an error!", error);
        });
    }, 1000);
  };

  vendorSignin = () => {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });
    console.log("vendorSignin");
    fetch(
      "https://work-web-server.herokuapp.com/vendors/login",
      //"http://localhost:5000/vendors/login",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: this.state.signInEmail,
          password: this.state.signInPassword,
        }),
      }
    )
      .then((response) => response.json())
      .then((res) => {
        if (res._id) {
          this.setState({
            userData: res,
          });
          setTimeout(() => {
            this.setState(({ loadings }) => {
              const newLoadings = [...loadings];
              newLoadings[0] = false;

              return {
                loadings: newLoadings,
              };
            });
          }, 6000);
          message.success({
            content: "Logged in successfully",
            style: {
              marginTop: "5vh",
              lineHeight: "5vh",
            },
          });
          console.log("Logged In");
          this.setState(({ loadings }) => {
            const newLoadings = [...loadings];
            newLoadings[0] = false;

            return {
              loadings: newLoadings,
            };
          });
          localStorage.setItem("userData", JSON.stringify(res));
        } else {
          if (res === "Vendor not found" || res === "Password Incorrect")
            message.warning({
              content: "Invalid Enteries!",
              duration: 2,
              style: {
                marginTop: "5vh",
                lineHeight: "5vh",
              },
            });
          this.setState({
            errors: res,
          });
          console.log("Error: ", res);
          setTimeout(() => {
            this.setState(({ loadings }) => {
              const newLoadings = [...loadings];
              newLoadings[0] = false;

              return {
                loadings: newLoadings,
              };
            });
          }, 0);
        }
      });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onChangeProgram = (e) => {
    this.setState({ experiencedPrograms: e });
  };

  render() {
    return (
      <div>
        <Button
          className="applyButtonProgram "
          onClick={() => {
            // this.props.setSelectedJob(item);
            this.setState({
              isSignUp: true,
            });
          }}
        >
          {" Apply Now ->"}
        </Button>
        <Modal show={this.state.isSignUp}>
          <Form
            scrollToFirstError={true}
            initialValues={{ remember: true }}
            onFinish={this.onFinish}
            labelAlign="left"
          >
            <ModalHeader>
              <ModalTitle>Sign Up As A Center</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <Form.Item
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please enter your first name!",
                  },
                ]}
              >
                <Input
                  name="firstName"
                  id="firstName"
                  value={this.state.firstName}
                  onChange={this.onChange}
                  placeholder="First Name"
                />
              </Form.Item>
              <Form.Item
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "Please enter your last name!",
                  },
                ]}
              >
                <Input
                  name="lastName"
                  id="lastName"
                  value={this.state.lastName}
                  onChange={this.onChange}
                  placeholder="Last Name"
                />
              </Form.Item>
              <Form.Item
                name="dob"
                label="DOB"
                rules={[
                  {
                    required: true,
                    message: "Please select your DOB!",
                  },
                ]}
              >
                <DatePicker name="dob" onChange={this.handleChange} />
              </Form.Item>

              <Label className="red">{this.state.sameEmailError}</Label>
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not a valid E-mail!",
                  },
                  {
                    required: true,
                    message: "Please enter your email!",
                  },
                ]}
              >
                <Input
                  type="email"
                  name="email"
                  id="email"
                  value={this.state.email}
                  onChange={this.onChange}
                  placeholder="Email"
                />
              </Form.Item>
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Please enter your phone number!",
                  },
                  {
                    len: 10,
                    message: "Phone number length is invalid",
                  },
                ]}
              >
                <Input
                  type="number"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.onChange}
                  addonBefore={"+92"}
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                name="organization"
                rules={[
                  {
                    required: true,
                    message: "Please enter your organization's name!",
                  },
                ]}
              >
                <Input
                  name="organization"
                  id="organization"
                  value={this.state.organization}
                  onChange={this.onChange}
                  placeholder="Organization Name"
                />
              </Form.Item>
              <Form.Item
                name="skypeId"
                rules={[
                  {
                    required: true,
                    message: "Please enter your skype Id!",
                  },
                ]}
              >
                <Input
                  name="skypeId"
                  id="skypeId"
                  value={this.state.skypeId}
                  onChange={this.onChange}
                  placeholder="Skype Id Name"
                />
              </Form.Item>
              <Form.Item
                name="csrHeadcount"
                rules={[
                  {
                    required: true,
                    message: "Please enter your CSR Headcount!",
                  },
                ]}
              >
                <Input
                  type="number"
                  name="csrHeadcount"
                  id="csrHeadcount"
                  value={this.state.csrHeadcount}
                  onChange={this.onChange}
                  placeholder="CSR Headcount"
                />
              </Form.Item>
              <Form.Item
                name="experiencedPrograms"
                label="Experienced Programs"
                // rules={[{ required: true, message: "Please select gender!" }]}
              >
                <Select
                  name="experiencedPrograms"
                  placeholder="Experienced Programs"
                  onChange={this.onChangeProgram}
                >
                  <Option value="Final Expense - Lead Gen">
                    Final Expense - Lead Gen
                  </Option>
                  <Option value="Final Expense - Live Transfers">
                    Final Expense - Live Transfers
                  </Option>
                  <Option value="Auto Insurance">Auto Insurance</Option>
                  <Option value="Auto Warranty">Auto Warranty</Option>
                  <Option value="Home Security">Home Security</Option>
                  <Option value="Solar">Solar</Option>
                  <Option value="DME">DME</Option>
                  <Option value="UK Campaigns">UK Campaigns</Option>
                  <Option value="Med Supp">Med Supp</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>

              {/* <Form.Item
                  name="saleManagerPassword"
                  label="Sale Manger Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your sale manager's password!",
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password
                    name="password"
                    value={this.state.center.saleManager.password}
                    //onChange={this.onPassword1Change}
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="Sale Manger Password"
                  />
                </Form.Item> */}
              <Form.Item
                name="password1"
                label="Create Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter your Password!",
                  },
                ]}
                hasFeedback
              >
                <Input.Password
                  name="password1"
                  value={this.state.password1}
                  onChange={this.onChange}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>
              <Form.Item
                name="password2"
                label="Confirm Password"
                dependencies={["password1"]}
                rules={[
                  {
                    required: true,
                    message:
                      "Please enter your password again for confirmation!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password1") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("Passwords do not match");
                    },
                  }),
                ]}
                hasFeedback
              >
                <Input.Password
                  name="password2"
                  value={this.state.password2}
                  onChange={this.onChange}
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Re-Enter Password"
                />
              </Form.Item>
            </ModalBody>
            <ModalFooter>
              <Button
                type="primary"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  borderColor: "black",
                }}
                onClick={() => {
                  console.log("Add Create Center function");
                  this.onSubmit();
                  this.setState({ isSignUp: false });
                }}
              >
                Create Center
              </Button>
              <Button
                type="primary submit"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  borderColor: "black",
                }}
                onClick={this.cancel}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    );
  }
}
